export default "__VITE_ASSET__a434649a__"